(function () {
  function toggleRow(btn) {
    const row = btn.closest('.pia__row');
    const panel = row.querySelector('.pia__panel');
    const expanded = btn.getAttribute('aria-expanded') === 'true';
    if (expanded) {
      btn.setAttribute('aria-expanded', 'false');
      panel.hidden = true;
      panel.classList.remove('is-open');
    } else {
      // Close others if single-open
      const wrap = row.closest('.pia');
      if (wrap && wrap.dataset.singleOpen === 'true') {
        wrap.querySelectorAll('.pia__toggle[aria-expanded="true"]').forEach((b) => {
          if (b !== btn) {
            b.setAttribute('aria-expanded', 'false');
            const p = document.getElementById(b.getAttribute('aria-controls'));
            if (p) { p.hidden = true; p.classList.remove('is-open'); }
          }
        });
      }
      btn.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
      panel.classList.add('is-open');
    }
  }

  // Click
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.pia__toggle');
    if (!btn) return;
    toggleRow(btn);
  });

  // Keyboard: open/close with Enter or Space
  document.addEventListener('keydown', function (e) {
    const btn = e.target.closest('.pia__toggle');
    if (!btn) return;
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      toggleRow(btn);
    }
  });
})();
